import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.5 12.5V5H11.5V12.5L4 12.5V13.5H11.5V21H12.5V13.5H20V12.5L12.5 12.5Z", fill: "black" }));
const ForwardRef = forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
